
import { defineComponent } from 'vue';
import router from '../routes';
export default defineComponent({
  name: 'BaseRouter',
  beforeMount(): void {
    router.push('/projectManager');
  }
});
